import store from './../../store'
import users from './user.js'
import role from './role.js'
export default {

    path: "/administration",
    name: "Administration",
    component: () =>
        import(
            "../../layouts/AdminLayout.vue"
        ),
    meta: { requiresAuth: true },
    children: [
        ...users,
        ...role,
        {
            path: "usersList",
            name: "Users",
            component: () =>
                import(
                    "../../views/administration/Users.vue"
                ),
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (store.state.authentication.authorizations) {
                    if (
                        store.state.authentication.authorizations.users.read
                    )
                        next();
                    else next(false);
                } else {
                    next("/administration");
                }
            },
        },
        // {
            
        //     beforeEnter: (to, from, next) => {
        //         if (store.state.authentication.authorizations) {
        //             if (
        //                 store.state.authentication.authorizations.roles.read
        //             )
        //                 next();
        //             else next(false);
        //         } else {
        //             next("/administration");
        //         }
        //     },
        // },
        {
            path: "stock-journal-roles",
            name: "StockJournalRoles",
            component: () =>
                import("../../views/administration/StockJournalRoles.vue"),
            meta: { requiresAuth: true },
            beforeEnter: (to, from, next) => {
                if (store.state.authentication.authorizations) {
                    if (
                        store.state.authentication.authorizations.roles.read
                    )
                        next();
                    else next(false);
                } else {
                    next("/administration");
                }
            },
        },
    ],
}